import 'remixicon/fonts/remixicon.css';
import { useParams } from "react-router-dom";
import { TeacherData } from '../../store/viewmodels/TeacherViewModel';
import { useAppSelector } from '../../store/Hooks';
import { Student } from '../../store/viewmodels/StudentViewModel';
import ModalWrapper from '../utils/modal/ModalWrapper';
import AnswerSetResultsModal from './AnswerSetResultsModal';
import { AnswerSetResult } from '../../store/viewmodels/AnswerSetViewModel';
import StudentResultsOverView from './StudentResultsOverview';
import { ResultsTaskList } from './results/ResultsTaskList';
import { useEffect, useState } from 'react';
import ResultsFiles from './results/ResultsFiles';

interface ResultsInfoParams {
    studentId?: string,
}

const emptyAnswerSet = { id: undefined, itemset: { id: -1, type: "", name: "" }, student: -1, answers: [], start_time: "", end_time: "" };

function ResultsInfo(): JSX.Element {
    let { studentId } = useParams<ResultsInfoParams>();

    const [isModalVisible, setModalVisible] = useState(false);
    const [selectedAnswerset, setSelectedAnswerset] = useState<AnswerSetResult>(emptyAnswerSet);

    const teacherData: TeacherData = useAppSelector(state => state.teacherData);
    const user = teacherData.isAuthenticated ? teacherData.teacher : null;
    const allStudents = user ? user.students : [];
    const student: Student | undefined = allStudents.find(student => student.id.toString() === studentId);
    const [content, setContent] = useState(<></>);

    const showModal = () => {
        setModalVisible(wasModalVisible => !wasModalVisible);
        setSelectedAnswerset(emptyAnswerSet);
    }

    const showSummary = () => {
        setContent(summaryModalContent);
        showModal();
    }

    const showResultModal = () => {
        setContent(<AnswerSetResultsModal close={showModal} student={student} answerSet={selectedAnswerset} />);
        showModal();
    }

    const showAllFiles = () => {
        setContent(<ResultsFiles close={showModal} student={student} />)
        showModal();
    }

    useEffect(() => {
        if (selectedAnswerset.id !== undefined) {
            showResultModal();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAnswerset])

    const summaryModalContent = <StudentResultsOverView student={student} close={showModal} />;

    return (
        <div className="p-8 w-full">
            {<ModalWrapper isVisible={isModalVisible} onBackdropClick={showModal} content={content} type="result" />}
            <div className="md:flex md:flex-grow border-b border-gray-200 pb-2">
                <div className="md:flex md:flex-grow">
                    <h1 className="text-2xl font-extrabold text-gray-900">{student?.identification}</h1>
                    <h1 className="md:ml-4 text-2xl text-gray-500">{student?.username}</h1>
                </div>
                <div className="pt-2 pb-2 md:m-0 md:p-0 md:justify-end">
                    <button type="button" onClick={showSummary} className={"py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"}>Yhteenveto</button>
                </div>
            </div>
            <div>
                <p className="mt-4 mb-4">
                    Näet tarkempia tietoja tehtävästä painamalla teemojen alta tehtävän nimeä.
                </p>
            </div>
            <ResultsTaskList student={student} setSelectedAnswerset={setSelectedAnswerset} />
            <div className="w-full border-t border-gray-200 pt-2 pb-2 mt-2 mb-2 float-right">
                <button type="button" onClick={showAllFiles} className={"float-right py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"}>Kaikki tiedostot</button>
            </div>
        </div>
    );
}

export default ResultsInfo;